import { memo, useEffect } from "react";

interface GoogleTagManagerProviderProps {
    children: React.ReactNode;
}

const containerId = "GTM-NBSKJF9S";

export const GoogleTagManagerProvider = memo(function GoogleTagManagerProvider({
    children,
}: GoogleTagManagerProviderProps) {
    useEffect(() => {
        // Check if script already exists
        const scriptId = `gtm-script-${containerId}`;
        const noscriptId = `gtm-noscript-${containerId}`;

        if (!document.getElementById(scriptId)) {
            // Add GTM script
            const script = document.createElement("script");
            script.id = scriptId;
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
            document.head.appendChild(script);
        }

        if (!document.getElementById(noscriptId)) {
            // Add noscript fallback
            const noscript = document.createElement("noscript");
            noscript.id = noscriptId;
            noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${containerId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
            document.body.appendChild(noscript);
        }

        return () => {
            // Safe cleanup
            const script = document.getElementById(scriptId);
            if (script) document.head.removeChild(script);

            const noscript = document.getElementById(noscriptId);
            if (noscript) document.body.removeChild(noscript);
        };
    }, []);

    return <>{children}</>;
});

GoogleTagManagerProvider.displayName = "GoogleTagManagerProvider";
